import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const STORE_MENU: PermissionTableRowType = {
  name: '브랜드',
  key: 'BRAND_MANAGE',
  subRows: [
    {
      name: '브랜드 관리',
      key: PERMISSION_SUBJECTS.STORE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DOWNLOAD_EXCEL,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.STORE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '브랜드 상세조회',
          key: PERMISSION_SUBJECTS.STORE,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '브랜드 편집',
          key: PERMISSION_SUBJECTS.STORE,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '브랜드 엑셀 다운로드',
          key: PERMISSION_SUBJECTS.STORE,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
    {
      name: '브랜드 티어 관리',
      key: PERMISSION_SUBJECTS.STORE_TIER,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.UPDATE],
    },
    {
      name: '브랜드 상단 노출/노출 순서 관리',
      key: PERMISSION_SUBJECTS.STORE_EXPOSE,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.UPDATE],
    },
  ],
};
